import { createFileRoute } from '@tanstack/react-router';
import TemplateCreateView from '../bulk-import/templates/create/template-create-view';
export const Route = createFileRoute('/bulk-import/templates/create')({
  component: TemplateCreateView,
});
